import axios from "axios"
import { EmployeeServiceInterface } from "@type/employees.types"

const ROOT_PATH = "employees/services"
export default class EmployeesServices {
	static getEmployeeServiceByEmployeeId = (employeeId: string) =>
		axios.get<EmployeeServiceInterface[]>(`${ROOT_PATH}/?employee=${employeeId}`)
}
